<template>
	<div>
		<v-btn text color="error" small class="m-0" @click="close">
			<v-icon small left>mdi-cancel</v-icon>
			Cancelar
		</v-btn>
		<v-menu v-if="editMode" left transition="scale-transition">
			<template v-slot:activator="{ on, attrs }">
				<v-btn text color="error" small v-bind="attrs" v-on="on">
					<v-icon small left>mdi-delete</v-icon>
					ELIMINAR
				</v-btn>
			</template>
			<v-card>
				<v-card-title class="title text-center">
					Eliminar Actividad
				</v-card-title>
				<v-card-text class="text-center">
					¿Estas seguro de eliminar?
				</v-card-text>
				<div class="mx-2">
					<v-btn color="primary" small text>
						Cancelar
					</v-btn>
					<v-btn color="primary" small text @click="deleteActivity">
						Aceptar
					</v-btn>
				</div>
			</v-card>
		</v-menu>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
	props: {
		close: {
			type: Function,
			required: true,
		},
	},
	computed: {
		...mapGetters({
			editMode: 'Lodging/editMode',
			lodgingSelect: 'Lodging/lodgingSelect',
		}),
	},
	methods: {
		async deleteActivity() {
			await this.deleteLodging({
				id: this.lodgingSelect._id,
				currentRoute: this.$route.name,
			});
			this.close();
			this.$emit('delete-lodging-ok');
		},
		...mapActions({
			deleteLodging: 'Lodging/deleteLodging',
		}),
	},
};
</script>

<style lang="scss" scoped></style>
